import * as React from 'react';
import styled from 'styled-components';

type InputType =
  | 'text'
  | 'tel'
  | 'email'
  | 'password'
  | 'checkbox'
  | 'textarea'
  | 'submit'
  | undefined
  | string;

export interface IInput {
  type?: InputType;
  name?: string;
  label?: string;
  labelAfter?: string;
  pattern?: string;
  placeholder?: string;
  value?: string | number;
  error?: boolean;
  forwardRef?: any;
  required?: any;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  onFocus?: (e: any) => void;
  onKeyUp?: (e: any) => void;
}

export const Input: React.FC<IInput> = React.memo(
  React.forwardRef((props, ref) => {
    return (
      <StyledInputWrapper>
        {props.label ? (
          <label>
            {props.label}
            {props.labelAfter ? <span>{props.labelAfter}</span> : null}
          </label>
        ) : null}
        <StyledInput
          ref={ref}
          type={props.type}
          name={props.name}
          pattern={props.pattern}
          placeholder={props.placeholder}
          value={props.value}
          onKeyUp={props.onKeyUp}
          onChange={props.onChange}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          error={props.error}
          tabIndex={0}
          required={props.required}
        />
      </StyledInputWrapper>
    );
  })
);

const StyledInputWrapper = styled.div`
  width: 100%;
  margin: 4px auto;
  label {
    display: block;
    font-size: 1rem;
    color: ${(props) => props.theme.input.label};
    margin-bottom: 18px;
  }
  @media all and (max-width: 375px) {
    max-width: 20em;
    margin: 0 auto;
    padding-top: 1em;

    label {
      font-size: 14px;
    }
  }
`;

const StyledInput: any = styled.input`
  display: block;
  padding: 15px;
  width: 100%;
  background: ${({ theme }) => theme.input.background};
  font-size: ${(props) => props.theme.input.font.size};
  font-weight: 400;
  color: white;
  border: ${(props: any) =>
    props.error
      ? `solid 2px ${props.theme.input.error}`
      : 'solid 2px transparent'};
  outline: none;
  border-radius: 0;

  &[type='submit'] {
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }
  &::-webkit-input-placeholder {
    color: ${(props: any) => props.theme.input.placeholder};
  }

  :not(:valid) {
    background: ${({ theme }) => theme.input.error};
  }
`;
